import React, { useState, useEffect } from 'react'
import Modal from 'aldoo-ra/Modal'
import Typography from 'aldoo-ra/Typography'
import Button from 'aldoo-ra/Button'
import Input from 'aldoo-ra/Input'
import { showNotification } from 'aldoo-ra/Notification'

const RescheduleModal = ({ isOpen, onClose, release, onReschedule }) => {
  const [scheduledAt, setScheduledAt] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    if (isOpen && release?.scheduledAt) {
      // Convert ISO string to datetime-local format (YYYY-MM-DDTHH:mm)
      const date = new Date(release.scheduledAt)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const localDateTime = `${year}-${month}-${day}T${hours}:${minutes}`
      setScheduledAt(localDateTime)
    }
  }, [isOpen, release])

  const handleSubmit = async () => {
    if (!scheduledAt) {
      showNotification({
        message: 'Please select a date and time',
        className: 'bg-admin_error text-white'
      })
      return
    }

    // Validate that the new time is in the future
    const newScheduledDate = new Date(scheduledAt)
    const now = new Date()
    if (newScheduledDate <= now) {
      showNotification({
        message: 'Scheduled time must be in the future',
        className: 'bg-admin_error text-white'
      })
      return
    }

    setIsSubmitting(true)
    try {
      // Convert local datetime to ISO string
      const scheduledAtISO = newScheduledDate.toISOString()
      await onReschedule(scheduledAtISO)
      onClose()
    } catch (error) {
      console.error('Failed to reschedule:', error)
      showNotification({
        message: 'Failed to reschedule release: ' + error.message,
        className: 'bg-admin_error text-white'
      })
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Select when this release should be sent"
      variant="admin_centered"
      className="max-w-md"
    >
      <div className="space-y-4">
        <div>
          <Typography variant="admin_label" className="mb-2">
            Schedule Date & Time
          </Typography>
          <Input
            type="datetime-local"
            value={scheduledAt}
            onChange={(e) => setScheduledAt(e.target.value)}
            disabled={isSubmitting}
            variant="admin"
            className="w-full"
          />
        </div>

        <div className="flex gap-3 justify-end pt-4">
          <Button
            variant="admin_secondary"
            onClick={onClose}
            disabled={isSubmitting}
          >
            Cancel
          </Button>
          <Button
            variant="admin_primary"
            onClick={handleSubmit}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Rescheduling...' : 'Reschedule'}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default RescheduleModal
